import Vue from 'vue'
import VueRouter from 'vue-router'
import LoginComponent from '../components/login/LoginComponent'
import CloseRequestPasswordComponent from '../components/closerequestpassword/CloseRequestPasswordComponent'
import AdminComponent from '../components/AdminComponent'
import DashboardComponent from '../components/dashboard/DashBoardComponent'
import UserComponent from '../components/users/UserComponent'
import TenantComponent from '../components/tenants/TenantComponent'
import AccountComponent from '../components/accounts/AccountComponent'

import store from '../store/index.js'

// Remova esta linha — não é mais usada
// import { NAME_TOKEN } from '../config/config'

Vue.use(VueRouter)

const routes = [
  { path: '/login', component: LoginComponent, name: 'login' },
  { path: '/closerequestpassword', component: CloseRequestPasswordComponent, name: 'closerequestpassword' },
  
  {
    path: '/admin',
    component: AdminComponent,
    meta: { auth: true },
    children: [
      { path: '/dashboard', component: DashboardComponent, name: 'admin.dashboard' },
      { path: '/users', component: UserComponent, name: 'admin.users.index' },
      { path: '/tenants', component: TenantComponent, name: 'admin.tenants.index' },
      { path: '/accounts', component: AccountComponent, name: 'admin.accounts.index' }
    ]
  },

  { path: '/', component: LoginComponent, name: 'root' }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// Guard de autenticação
router.beforeEach(async (to, from, next) => {
  // Se a rota requer autenticação
  if (to.matched.some(record => record.meta.auth)) {
    
    // Se o Vuex já sabe que está autenticado → permite
    if (store.state.auth.authenticated) {
      return next()
    }

    // Se NÃO está autenticado no Vuex, verifica com o backend
    try {
      await store.dispatch('checkLogin')
      next() // se checkLogin resolver, está logado
    } catch (error) {
      // Se falhar, redireciona para login
      store.commit('CHANGE_URL_BACK', to.name)
      next({ name: 'login' })
    }
  } else {
    // Rota pública → permite
    next()
  }
})

export default router
